import { gql } from '@apollo/client'

export const CREDIT_ACCOUNT_QUERY = gql`
  query CreditAccount($creditAccountID: ID!) {
    creditAccount(creditAccountID: $creditAccountID) {
      creditAccountID
      walletID
      entity {
        entityType
        entityID
        entityCode
        displayEntityCode
        entityName
      }
      minBalance
      balance
      reservable
      maxReservable
    }
  }
`

export const CREDIT_ACCOUNTS_QUERY = gql`
  query CreditAccounts($walletID: ID!) {
    creditAccounts(walletID: $walletID) {
      creditAccountID
      walletID
      entity {
        entityType
        entityID
        entityCode
        displayEntityCode
        entityName
      }
      minBalance
      balance
      reservable
      maxReservable
    }
  }
`

export const REFERENCES_QUERY = gql`
  query References($transactionID: ID!) {
    references(transactionID: $transactionID) {
      type
      displayId
      metadata {
        key
        value
      }
    }
  }
`
